import { takeLatest, put } from "redux-saga/effects";

import { FETCH_DATA_OPTIONS_REQUEST, SAVE_DATA_OPTIONS_REQUEST } from "./constants";
import { fetchOptionsSuccess, saveDataOptionsSuccess } from "./actions";

import * as Api from '../../../services';

function* fetchOptionsRequest() {
    const { data } = yield Api.getOptionsAPI();
    yield put(fetchOptionsSuccess(data));
}

function* saveDataOptionsRequest(payload) {
    let registerRoom = JSON.parse(localStorage.getItem('_dataRegisterRoom') || '{}');
    registerRoom = { ...registerRoom, ...payload.payload };
    localStorage.setItem('_dataRegisterRoom', JSON.stringify(registerRoom));
    yield put(saveDataOptionsSuccess(payload.payload));
}

export function* saga() {
    yield takeLatest(FETCH_DATA_OPTIONS_REQUEST, fetchOptionsRequest);
    yield takeLatest(SAVE_DATA_OPTIONS_REQUEST, saveDataOptionsRequest);
}
